/* eslint max-classes-per-file: 0 */

import {
  Participant as Data,
  ParticipantCollection as Collection,
  ParticipantUser,
  ParticipantUserCollection,
} from '@/typings/api/Participant'

import { Fabric } from '@/store/createCrudModule'
import { ParticipantsAdapter } from './ParticipantsAdapter'
import { unionBy } from 'lodash'
import { downloadLinkByPost } from '@/helpers/downloadBlob'


export const fabric = Fabric<Data, Collection>()

type S = ParticipantsState
type G = ParticipantsGetters
type M = ParticipantsMutations
type A = ParticipantsActions


export class ParticipantsState extends fabric.State {
  public users: ParticipantUser[] | null = [];
}

export class ParticipantsGetters extends fabric.Getters<S> {
}

export class ParticipantsMutations extends fabric.Mutations<S> {
  public setUsers(payload?: ParticipantUser[]) {
    this.state.users = payload || null
  }

  public addUsers(payload?: ParticipantUser[]) {
    if (!this.state.users || !payload) return
    this.state.users = unionBy(this.state.users, payload, 'id')
  }

  public removeUser(payload?: ParticipantUser) {
    if (!this.state.users || !payload) return

    const value = this.state.users.slice()
    const index = value.findIndex(({ id }) => id === payload.id)
    if (index >= 0) {
      value.splice(index, 1)
      this.state.users = value
    }
  }
}

export class ParticipantsActions extends fabric.Actions<S, G, M, A> {
  protected readonly adapter = new ParticipantsAdapter();

  protected readonly idName = 'id';

  public copy(options: Data) {
    return this.adapter.api.copy(options.id)
  }

  public async getUsers(options: Data) {
    const { data } = await this.adapter.api.getUsers<ParticipantUserCollection>(options.id)
    // this.mutations.setUsers(data.data)

    return data
  }

  public async addUsers({ options, users }: { options: Data; users: ParticipantUser[] }) {
    if (!users) return

    if (users.length === 1) {
      await this.adapter.api.addUser(options.id, { user_id: users[0].id })
    } else {
      await this.adapter.api.addUser(options.id, { user_ids: users.map(({ id }) => id) })
    }
    this.mutations.addUsers(users)
  }

  public async removeUser({ options, user }: {options: Data; user: ParticipantUser}) {
    if (!user) return

    await this.adapter.api.removeUser(options.id, { user_id: user.id })
    this.mutations.removeUser(user)
  }

  public exportParticipantUsers(options: { id: Data['id'] }) {
    const link = this.adapter.api.export(options.id)
    window.open(link, '_blank')
  }

  public async exportParticipants(participants: Data[]) {
    const link = this.adapter.api.exportList()

    await downloadLinkByPost(link, { participants_ids: participants.map(({ id }) => id) })
  }
}
